"use server";
import { redirect } from "@/i18n/navigation";
import { ApiResponse, loginPayload, loginResponse } from "@/types/api";
import { getLocale, getTranslations } from "next-intl/server";
import { cookies } from "next/headers";
import { z } from "zod";

const schema = z.object({
    license: z.string().min(1, "auth.license"),
    password: z.string().min(1, "auth.password")
})

export async function loginAction(
    state: ApiResponse<string | undefined> | undefined,
    formData: FormData
): Promise<ApiResponse<string | undefined> | undefined>{
    const t = await getTranslations("error");
    
    const parsed = schema.safeParse({
        
        license: formData.get("license"),
        password: formData.get("password"),
    });

    

    if (!parsed.success){
        return {
            success: false,
            error: t(parsed.error.issues[0].message)
        }
    }

    const payload : loginPayload = {
        license: parsed.data.license,
        password: parsed.data.password
    }

    const res = await fetch(process.env.NEXT_PRIVATE_API_URL + "/auth/login",{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    })

    if (res.status == 500) {
        return {
            success: false,
            error: t("serverError")
        }
    }

    const resjson: ApiResponse<string> = await res.json();

    if(!resjson.success || !resjson.data) {
        if (resjson.error) {
            return {
                success: false,
                error: t(resjson.error)
            }
        }
        return {
            success: false,
            error: t("serverError")
        }
    }
    const cookieStore = await cookies();


    cookieStore.set("refreshT", resjson.data, {
        secure: true,
        httpOnly: true,
        sameSite: "strict",
        maxAge: 60 * 60 * 24 * 30
    })

    //redirect({locale: await getLocale(), href: "/dashboard"});
    return {
        success: true,
        data: "success"
    }


}